
const settings = {
    autoPlay: true,
    animation: "fade",
    indicators: true,
    interval: 5000,
    navButtonsAlwaysVisible: false,
    navButtonsAlwaysInvisible: true,
    cycleNavigation: true,
    fullHeightHover: true,
    swipe: true,
    transitionTime:500
}

export default settings;